import { CheckCircleOutlined } from '@ant-design/icons'
import { Badge, Button, Card } from 'antd'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import { exportToCSV, exportToExcel } from '../../../core/common/GlobalFunctions/exportTableData'
import { useState } from 'react'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'

const PayrollDashboard = () => {

    const [selectedYear, setSelectedYear] = useState('Select Year');
    const [selectedMonth, setSelectedMonth] = useState('Select Month');
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 14 }, (_, index) => currentYear - index);
    const handleYearSelect = (year: string) => {
        setSelectedYear(year);
        setSelectedMonth('Select Month');
    };

    const handleMonthSelect = (month: string) => {
        setSelectedMonth(month);
    };
    return (

        <>
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Employee Salary</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">HR</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Employee Salary
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            

                            <div className="d-flex">
                                {/* Year Dropdown */}
                                <div className="mb-2 me-2">
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-primary dropdown-toggle d-flex align-items-center"
                                            type="button"
                                            id="dropdownYearButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <i className="ti ti-calendar me-2" />
                                            {selectedYear}
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownYearButton">
                                            {/* You can replace these years with dynamic data if needed */}
                                            {years?.map((year: any, index: any) => (
                                                <li key={index}>
                                                    <a className="dropdown-item" href="#" onClick={() => handleYearSelect(year)}>
                                                        {year}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                {/* Month Dropdown (only visible after selecting a year) */}
                                {selectedYear !== 'Select Year' && (
                                    <div className="mb-2 me-2">
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-primary dropdown-toggle d-flex align-items-center"
                                                type="button"
                                                id="dropdownMonthButton"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <i className="ti ti-calendar me-2" />
                                                {selectedMonth}
                                            </button>
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMonthButton">
                                                {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((month, index) => (
                                                    <li key={index}>
                                                        <a className="dropdown-item" href="#" onClick={() => handleMonthSelect(month)}>
                                                            {month}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>


                           

                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                   
                </div>

                <div className="container mt-4">
                    <Card className="p-3 shadow-sm">
                        <div className="d-flex justify-content-between align-items-center">
                            <h5>
                                Process Payroll for: <b>March 2025</b> <Badge color="green" text="Approved" />
                            </h5>
                            <Button type="primary">Create Payroll</Button>
                        </div>
                        <p className="text-muted">1 Mar 2025 - 31 Mar 2025</p>
                        <div className="bg-light p-3 rounded d-flex justify-content-between align-items-center">
                            <h4>
                                ₹ 60,285.00 <Badge color="blue" text="Salary In - Progress" />
                            </h4>
                        </div>
                        <Card className="mt-3 p-3 shadow-sm">
                            <h3>₹ 60.3K</h3>
                            <p className="text-muted">Net Pay</p>
                            <p>Actual Pay: <b>₹ 60,285.00</b></p>
                            <p>Bonus & Incentives: <b>₹ 0.00</b></p>
                            <p>Arrears: <b>₹ 0.00</b></p>
                            <p>Advance: <b>₹ 0.00</b></p>
                            <p>Reimbursement: <b>₹ 0.00</b></p>
                            <p>Payment Date: <b>7th April, 2025</b></p>
                            <p className="text-success">
                                <CheckCircleOutlined /> No Salary is on Hold
                            </p>
                            <p>13 Nos. Active Employees in Payroll</p>
                        </Card>
                        <div className="row mt-3">
                            <div className="col-md-4">
                                <Card className="p-3 text-center">
                                    <h5>Employee’s State Insurance (ESI)</h5>
                                    <h4 className="text-warning">₹ 0.00</h4>
                                    <p>Last Date to Deposit: 15th April, 2025</p>
                                </Card>
                            </div>
                            <div className="col-md-4">
                                <Card className="p-3 text-center">
                                    <h5>Employee’s Provident Fund (EPF)</h5>
                                    <h4 className="text-warning">₹ 0.00</h4>
                                    <p>Last Date to Deposit: 15th April, 2025</p>
                                </Card>
                            </div>
                            <div className="col-md-4">
                                <Card className="p-3 text-center">
                                    <h5>Tax Deducted at Source (TDS)</h5>
                                    <h4 className="text-warning">₹ 0.00</h4>
                                    <p>Last Date to Deposit: 7th April, 2025</p>
                                </Card>
                            </div>
                        </div>
                    </Card>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>

        </>

    )
}

export default PayrollDashboard